(function () {
  var cfg = window.theme && theme.vaughanCoffee;
  if (!cfg || !cfg.variantId || !cfg.coffeeHandle) return;

  var PARENT_HANDLES = cfg.parentHandles;
  var COFFEE_HANDLE = cfg.coffeeHandle;
  var VARIANT_ID = String(cfg.variantId);
  var removingCoffee = false;
  var syncingOffer = false;

  function cartUrl(path) {
    return (theme.routes && theme.routes[path]) || path;
  }

  function formatMoney(cents) {
    if (theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function fetchCart() {
    return fetch(cartUrl('cart') || '/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (r) {
      return r.json();
    });
  }

  function hasVaughanParent(cart) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (PARENT_HANDLES.indexOf(items[i].handle) !== -1) return true;
    }
    return false;
  }

  function coffeeLines(cart) {
    var items = (cart && cart.items) || [];
    var out = [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].handle === COFFEE_HANDLE) out.push(items[i]);
    }
    return out;
  }

  function coffeeQty(cart) {
    var lines = coffeeLines(cart);
    var qty = 0;
    for (var i = 0; i < lines.length; i++) qty += lines[i].quantity;
    return qty;
  }

  function rebuildCartUi() {
    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  function notifyCartUpdated(cart) {
    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        detail: { cart: cart }
      })
    );
  }

  function removeCoffeeLines(cart) {
    var lines = coffeeLines(cart);
    if (!lines.length) return Promise.resolve(cart);

    removingCoffee = true;
    var chain = Promise.resolve();
    lines.forEach(function (line) {
      chain = chain.then(function () {
        return theme.cart.changeItem(line.key, 0);
      });
    });
    return chain
      .then(function (lastCart) {
        removingCoffee = false;
        notifyCartUpdated(lastCart);
        rebuildCartUi();
        return lastCart;
      })
      .catch(function () {
        removingCoffee = false;
      });
  }

  function ensureCoffeeAllowed(cart) {
    if (removingCoffee) return Promise.resolve(cart);
    if (!coffeeQty(cart)) return Promise.resolve(cart);
    if (hasVaughanParent(cart)) return Promise.resolve(cart);
    return removeCoffeeLines(cart);
  }

  function bodyHasCoffeeVariant(body) {
    if (!body) return false;

    if (typeof body === 'string') {
      try {
        var params = new URLSearchParams(body);
        if (params.get('id') === VARIANT_ID) return true;
        var items = params.getAll('items[][id]').concat(params.getAll('items[0][id]'));
        if (items.indexOf(VARIANT_ID) !== -1) return true;
      } catch (e) {}
      return body.indexOf('id=' + VARIANT_ID) !== -1 || body.indexOf('"id":' + VARIANT_ID) !== -1;
    }

    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      var id = body.get('id');
      return id != null && String(id) === VARIANT_ID;
    }

    if (typeof body === 'object') {
      if (body.id != null && String(body.id) === VARIANT_ID) return true;
      if (Array.isArray(body.items)) {
        for (var i = 0; i < body.items.length; i++) {
          if (body.items[i] && String(body.items[i].id) === VARIANT_ID) return true;
        }
      }
    }

    return false;
  }

  function isCartAddUrl(url) {
    var s = String(url || '');
    return s.indexOf('/cart/add') !== -1;
  }

  function blockMessage() {
    return cfg.message || 'Turkish Coffee is only available with a Vaughan Mosaic or Ceramic class in your cart.';
  }

  function showError(msg) {
    window.alert(msg);
  }

  function installFetchGuard() {
    if (!window.fetch || window.__vaughanCoffeeFetchPatched) return;
    window.__vaughanCoffeeFetchPatched = true;
    var originalFetch = window.fetch.bind(window);

    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : input && input.url;
      init = init || {};

      if (!isCartAddUrl(url)) {
        return originalFetch(input, init);
      }

      var body = init.body;
      if (!bodyHasCoffeeVariant(body)) {
        return originalFetch(input, init);
      }

      return fetchCart().then(function (cart) {
        if (hasVaughanParent(cart)) {
          return originalFetch(input, init);
        }
        showError(blockMessage());
        return Promise.resolve(
          new Response(JSON.stringify({ status: 422, description: blockMessage() }), {
            status: 422,
            headers: { 'Content-Type': 'application/json' }
          })
        );
      });
    };
  }

  function renderOffer(cart) {
    var mounts = document.querySelectorAll('[data-vaughan-coffee]');
    if (!mounts.length) return;

    var clearMounts = function () {
      mounts.forEach(function (el) {
        el.innerHTML = '';
      });
    };

    // Only show the offer when Vaughan is in cart and coffee is not yet added.
    if (!hasVaughanParent(cart) || coffeeQty(cart) > 0) {
      clearMounts();
      return;
    }

    var img = cfg.image
      ? '<div class="vaughan-coffee__image"><img src="' +
        cfg.image +
        '" alt="' +
        escapeHtml(cfg.title) +
        '" width="60" height="60" loading="lazy"></div>'
      : '';

    var html =
      '<div class="vaughan-coffee">' +
      img +
      '<div class="vaughan-coffee__content">' +
      '<div class="vaughan-coffee__label">Add-on</div>' +
      '<p class="vaughan-coffee__title">' +
      escapeHtml(cfg.title) +
      '</p>' +
      '<div class="vaughan-coffee__price">' +
      formatMoney(cfg.price) +
      '</div>' +
      '</div>' +
      '<div class="vaughan-coffee__actions">' +
      '<button type="button" class="btn btn--small vaughan-coffee__add" data-vc-add>Add Turkish Coffee</button>' +
      '</div>' +
      '</div>';

    mounts.forEach(function (el) {
      el.innerHTML = html;
    });
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function syncFromCart() {
    if (syncingOffer) return Promise.resolve();
    syncingOffer = true;
    return fetchCart()
      .then(function (cart) {
        return ensureCoffeeAllowed(cart).then(function (nextCart) {
          renderOffer(nextCart || cart);
          return nextCart || cart;
        });
      })
      .finally(function () {
        syncingOffer = false;
      });
  }

  function addCoffee() {
    return fetchCart().then(function (cart) {
      if (!hasVaughanParent(cart)) {
        showError(blockMessage());
        return;
      }

      return fetch(cartUrl('cartAdd') || '/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ id: Number(VARIANT_ID), quantity: 1 })
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok || data.status === 422) {
              throw new Error((data && data.description) || blockMessage());
            }
            return data;
          });
        })
        .then(function (product) {
          document.dispatchEvent(
            new CustomEvent('ajaxProduct:added', {
              detail: { product: product }
            })
          );
          rebuildCartUi();
          return syncFromCart();
        })
        .catch(function (err) {
          showError(err.message || blockMessage());
        });
    });
  }

  function changeCoffeeQty(delta) {
    return fetchCart().then(function (cart) {
      if (!hasVaughanParent(cart) && delta > 0) {
        showError(blockMessage());
        return;
      }

      var lines = coffeeLines(cart);
      if (!lines.length) {
        if (delta > 0) return addCoffee();
        return;
      }

      var line = lines[0];
      var next = line.quantity + delta;
      if (next < 0) next = 0;

      return theme.cart.changeItem(line.key, next).then(function (updated) {
        notifyCartUpdated(updated);
        rebuildCartUi();
        renderOffer(updated);
        return ensureCoffeeAllowed(updated);
      });
    });
  }

  function onClick(e) {
    var addBtn = e.target.closest('[data-vc-add]');
    if (addBtn) {
      e.preventDefault();
      addCoffee();
      return;
    }

    var deltaBtn = e.target.closest('[data-vc-qty-delta]');
    if (deltaBtn) {
      e.preventDefault();
      changeCoffeeQty(Number(deltaBtn.getAttribute('data-vc-qty-delta')));
    }
  }

  function lockCoffeeProductPage() {
    if (!document.body || !cfg.isCoffeeProduct) return;

    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        showError(blockMessage());
      });
    });

    document.querySelectorAll('[name="add"], .shopify-payment-button, .add-to-cart').forEach(function (el) {
      el.style.display = 'none';
    });
  }

  installFetchGuard();
  document.addEventListener('click', onClick);
  document.addEventListener('cart:updated', function (evt) {
    var cart = evt.detail && evt.detail.cart;
    if (cart) {
      ensureCoffeeAllowed(cart).then(function (next) {
        renderOffer(next || cart);
      });
    } else {
      syncFromCart();
    }
  });
  document.addEventListener('ajaxProduct:added', function () {
    syncFromCart();
  });
  document.addEventListener('cart:build', function () {
    syncFromCart();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      lockCoffeeProductPage();
      syncFromCart();
    });
  } else {
    lockCoffeeProductPage();
    syncFromCart();
  }
})();
